import { message } from "antd"
import { HttpClient } from "~/api/HttpClient"
import { t } from "../../../languages/i18n"

const API_PREFIX_PAGES_PATH = "/api/pages"
const API_PREFIX_POSTS_PATH = "/api/posts"
const API_PREFIX_CATEGORIES_PATH = "/api/cateogries"
const API_PREFIX_MENUPREFERENCE_PATH = "/api/menu-preferences"
const API_PREFIX_BASESYSTEM_PATH = "/api/menu-preferences"

const fetchAllPages = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_PAGES_PATH}`)

    return response
  } catch (error) {
    message.error("Failed to fetch pages. Please try again.")
  }
}

const fetchAllPost = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_POSTS_PATH}`)

    return response
  } catch (error) {
    message.error(t("Failed to fetch posts. Please try again."))
  }
}
const fetchAllBases = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_BASESYSTEM_PATH}`)

    return response
  } catch (error) {
    message.error("Failed to fetch pages. Please try again.")
  }
}

const fetchAllCategories = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CATEGORIES_PATH}`)

    return response
  } catch (error) {
    message.error("Failed to fetch categories. Please try again.")
  }
}

const fetchAllMenuPreference = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_MENUPREFERENCE_PATH}`, {
      params: {
        populate: "*",
        locale: "all",
      },
    })
    return response
  } catch (error) {
    message.error("Failed to fetch categories. Please try again.")
  }
}

const menuService = {
  fetchAllPages,
  fetchAllPost,
  fetchAllCategories,
  fetchAllBases,
  fetchAllMenuPreference,
}

export default menuService
